import { View } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  label: string;
  value: string;
  bold?: boolean;
};

export default function CartReviewLine({ label, value, bold }: Props) {
  const tailwind = useTailwind();

  const variant = bold ? "titleLarge" : "titleMedium";
  const style = bold ? tailwind("font-bold") : undefined;

  return (
    <View style={tailwind("flex-row items-center justify-between")}>
      <Text variant={variant} style={style}>
        {label}
      </Text>
      <Text variant={variant} style={style}>
        {value}
      </Text>
    </View>
  );
}
